import React from 'react';
import styled, { css } from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Image from '@nubank/nuds-web/components/Image/Image';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

const StyledTypography = styled(Typography)`
  ${breakpointsMedia({
    xs: css`
      font-size: 30px;
      font-weight: 600;
    `,
    md: css`
      font-size: 32px;
    `,
    lg: css`
      font-size: 24px;
    `,
    xl: css`
      font-size: 28px;
    `,
  })}
`;

const Protection = () => (
  <Box
    background="linear-gradient(137.07deg, #9F2DEB 42.83%, #6200A3 86.85%)"
    borderRadius="12px"
    paddingHorizontal={{ xs: '8x', lg: '8x' }}
    paddingBottom={{ xs: '2x' }}
    marginHorizontal={{ xs: '8x', lg: ' 0' }}
    marginTop={{ xs: '32x' }}
    width="-webkit-fill-available"
    minHeight={{ xs: 'auto', lg: 'inherit' }}
  >

    <Box
      position="relative"
      top={{ xs: '-40px' }}
      display="flex"
      justifyContent={{ xs: 'center' }}
      marginRight={{ xs: '4x', lg: '4x' }}
    >
      <Image
        alt="Icono de una bolsa"
        src="mgm/lock-new.svg"
        width={{ xs: '68px', md: '71px' }}
        height={{ xs: '68px', md: '71px' }}
        webp={false}
        loading="lazy"
      />
    </Box>

    <StyledTypography
      intlKey="MGM.PROTECTION.TITLE"
      color="white"
      textAlign={{ xs: 'center' }}
      maxWidth={{ xs: '100%', md: '450px' }}
      margin="0 auto"
      whiteSpace={{ xs: 'pre-line' }}
      marginBottom={{ xs: '6x' }}
      marginTop={{ xs: '-8x' }}
    />

    <Typography
      variant="paragraph1"
      intlKey="MGM.PROTECTION.DESCRIPTION"
      color="white"
      intlValues={{
        strong: props => (
          <Typography tag="span" strong>
            {props }
          </Typography>
        ),
      }}
      textAlign={{ xs: 'center' }}
      maxWidth={{ xs: '100%', md: '450px' }}
      margin="0 auto"
      whiteSpace={{ xs: 'pre-line', md: 'inherit' }}
      marginBottom={{ xs: '6x' }}
    />
  </Box>
);

export default Protection;
